import routes from 'routes';

export const MALTA_TIFD_RETURN_TYPE_ID = (
  process.env.MALTA_TIFD_ID || ''
).trim();

export const isMaltaTifdReturnType = (returnTypeId?: string | null): boolean =>
  !!MALTA_TIFD_RETURN_TYPE_ID &&
  !!returnTypeId &&
  returnTypeId === MALTA_TIFD_RETURN_TYPE_ID;

export const maltaTifdMappingPath = (
  connectionId: string,
  mappingId?: string
): string => {
  if (mappingId) {
    return routes.returns.tifdEdit
      .replace(':connectionId', connectionId)
      .replace(':mappingId', mappingId);
  }

  return routes.returns.tifdAdd.replace(':connectionId', connectionId);
};

export const reportViewPath = (
  connectionId: string,
  mappingId: string,
  dataLogId: string,
  returnTypeId?: string | null
): string => {
  const template = isMaltaTifdReturnType(returnTypeId)
    ? routes.vat.tifdViewReportLink
    : routes.vat.viewReportLink;

  return template
    .replace(':connectionId', connectionId)
    .replace(':mappingId', mappingId)
    .replace(':dataLogId', dataLogId);
};

export const isTifdReportPath = (pathname: string): boolean =>
  pathname.startsWith(routes.vat.tifdReport);

export const returnMappingEditPath = (
  connectionId: string,
  mappingId: string,
  returnTypeId?: string | null
): string => {
  const template = isMaltaTifdReturnType(returnTypeId)
    ? routes.returns.tifdEdit
    : routes.returns.edit;

  return template
    .replace(':connectionId', connectionId)
    .replace(':mappingId', mappingId);
};
